// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:767.98px){.input-group-pass[data-v-bfb34d84]{flex-flow:column}.input-group-pass input[data-v-bfb34d84]{margin-bottom:1rem}}.invalid-feedback[data-v-bfb34d84]{bottom:-2rem;position:absolute}.form-control.is-invalid[data-v-bfb34d84],.was-validated .form-control[data-v-bfb34d84]:invalid{padding-right:.75rem!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
